import React from 'react';
import { useMsal } from '@azure/msal-react';
import Login from './Login';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { accounts } = useMsal();

  if (accounts.length === 0) {
    return <Login />;
  }

  return <>{children}</>;
}